import React, { useCallback } from 'react'

import { FlatList, FlatListProps } from 'widgets/FlatList'

import { Room } from 'types/chat'
import { UserType } from 'types/user'

import { ChatRoomRow } from './subcomponents/ChatRoomRow'
import { SearchResultRow } from './subcomponents/SearchResultRow'

type Props = Omit<FlatListProps<Room | UserType>, 'renderItem'>

export const ChatList = ({
  data,
  loading,
  onEndReached,
  isSearching = false,
  onRowSelect,
  ...rest
}: Props) => {
  const getRenderItem = useCallback(
    (item: Room | UserType): JSX.Element => {
      return isSearching ? (
        <SearchResultRow onSelect={onRowSelect} user={item as UserType} />
      ) : (
        <ChatRoomRow room={item as Room} />
      )
    },
    [isSearching, onRowSelect],
  )

  return (
    <FlatList<Room | UserType>
      data={data}
      keyExtractor={(room) => `${room.id}`}
      loading={loading}
      keyboardDismissMode='interactive'
      noContentProps={{
        message: !isSearching
          ? "You don't have any DMs yet."
          : 'There are no members that match that search.',
      }}
      onEndReached={onEndReached}
      renderItem={({ item }) => getRenderItem(item)}
      {...rest}
    />
  )
}
